import styled from 'styled-components';

export const ContainerDados = styled.div`
  background-color: #fff;
  padding: 6px;
  border: 1px solid #d7d7d7;
`;

export const PacienteLinha = styled.div`
  margin-right: -3px;
  margin-left: -3px;
  padding: 6px 0;
  font-size: 0.8rem;
  border-bottom: 1px solid #cfcfcf;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const PacienteLista = styled.div`
  display: flex;
  align-items: center;

  > img {
    border-radius: 4px;
    margin-right: 8px;
    width: 40px;
  }

  span {
    color: #6c757d;
  }
`;
